import { SecurityZonesModelBase } from './security-zones-model';
import { ZoneFeature } from './zones-base-interfaces';
import { GeofencesService } from '../services/geofences-service';
import { IndexedDBService } from '../../indexed-db/services/db_service';
import { isOnline } from '../utils/helpers';

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;
const env = (<any>window).appenv.services.staticdataapi;

export class SecurityZonesModelImpl extends SecurityZonesModelBase {
    async getSecurityZones(): Promise<ZoneFeature[] | null> {
        await this.fetchZones();

        const securityZones = this._zones;
        return securityZones;
    }

    constructor(geojson?: ZoneFeature[]) {
        super();
        if (geojson) {
            this._zones = geojson;
        } else {
            setInterval(() => this.fetchZones(), 60*60*1000); // refresh the list every 1h
        }
    }

    private _zones: ZoneFeature[] | null = null;

    private async fetchZones() {
        try {
            if (isVesselOnCloud && !isOnline()) {
                const cached = await IndexedDBService.zones.getByType('SECURITY');
                if (cached) {
                    this._zones = cached;
                }
                return;
            }
            const zones : ZoneFeature[] = await GeofencesService.fetchGeofenceByZone('SECURITY');
            if (zones) {
                this._zones = zones;
                await IndexedDBService.zones.save('SECURITY', zones);
            }
        } catch (error) {
            console.warn('Failed to fetch SECURITY zones from API, falling back to IndexedDB', error);
            const cached = await IndexedDBService.zones.getByType('SECURITY');
            if (cached) {
                this._zones = cached;
            }
        }
    }
}